import * as React from 'react';
import './receiptInfoPane.module.scss';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { inject, observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { BackButtonHeader } from './BackButtonHeader';
import { V3Routes } from '../../../routes';
import { Pane, PaneHeader, PaneSubHeader } from '../../molecules/mypage/page';
import { FormInput } from '../../atoms/forms/FormInput';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { observable } from 'mobx';
import { ReceiptInfoState } from './states/ReceiptInfoState';
import { SelectInput } from '../../atoms/forms/SelectInput';

type Props = {
    homeState: HomePageState;
    match: {
        params: {
            code: string;
        };
    };
};

@inject('homeState')
@observer
export class ReceiptInfoPane extends React.Component<Props> {
    @observable pageState = new ReceiptInfoState();

    componentDidMount(): void {
        this.pageState.init();
    }

    render() {
        const { submitting, formState } = this.pageState;
        const { code } = this.props.match.params;
        return (
            <Pane activeMenu="payments">
                {GlobalStatesV3.viewport.isMobile && <BackButtonHeader to={V3Routes.myPage()} />}
                <PaneHeader>領収書発行</PaneHeader>
                <div styleName="form-label">宛名</div>
                <FormInput
                    styleName="name"
                    name="name"
                    value={formState.getValue('name')}
                    placeholder=""
                    onChange={(e) => formState.setValue('name', e.target.value)}
                    error={formState.getError('name')}
                />
                <SelectInput
                    styleName="sm"
                    id="appelation"
                    value={formState.getValue('appelation')}
                    onChange={(e) => formState.setValue('appelation', e)}
                >
                    <option value="御中">御中</option>
                    <option value="様">様</option>
                </SelectInput>
                <div styleName="form-label">但し書き</div>
                <FormInput
                    styleName="purpose"
                    name="purpose"
                    value={formState.getValue('purpose')}
                    placeholder=""
                    onChange={(e) => formState.setValue('purpose', e.target.value)}
                    error={formState.getError('purpose')}
                />
                <div styleName="form-submit-button">
                    <Button type="primary" size="m" loading={submitting} onClick={() => this.pageState.submit(code)}>
                        領収書を発行する
                    </Button>
                </div>
            </Pane>
        );
    }
}
